import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { adminApi } from "../../lib/adminApi";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

export default function GenerationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [gen, setGen] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getGeneration(id)
      .then(setGen)
      .catch((e) => toast.error(e.message))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="text-center py-8">Loading...</div>;
  if (!gen) return <div className="text-center py-8">Generation not found</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Generation #{gen.id}</h1>
        <Button variant="outline" onClick={() => navigate("/admin/generations")}>Back</Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader><CardTitle>Details</CardTitle></CardHeader>
          <CardContent className="space-y-2">
            <div><strong>Store ID:</strong> {gen.store_id || "-"}</div>
            <div><strong>Model:</strong> {gen.model}</div>
            <div><strong>Duration:</strong> {gen.duration_ms ? `${(gen.duration_ms / 1000).toFixed(2)}s` : "-"}</div>
            <div><strong>Status:</strong> <Badge variant={gen.success ? "default" : "destructive"}>{gen.success ? "Success" : "Failed"}</Badge></div>
            <div><strong>Result Type:</strong> {gen.result_type}</div>
            <div><strong>Image ID:</strong> {gen.image_id || "-"}</div>
            <div><strong>Created:</strong> {new Date(gen.created_at).toLocaleString()}</div>
            {gen.error && <div className="text-red-600"><strong>Error:</strong> {gen.error}</div>}
          </CardContent>
        </Card>

        <Card>
          <CardHeader><CardTitle>Prompt Used</CardTitle></CardHeader>
          <CardContent>
            <pre className="whitespace-pre-wrap text-sm bg-gray-50 p-4 rounded-lg overflow-auto max-h-[500px]">
              {gen.prompt_text}
            </pre>
          </CardContent>
        </Card>
      </div>

      {gen.image_id && (
        <Card className="mt-6">
          <CardHeader><CardTitle>Generated Image</CardTitle></CardHeader>
          <CardContent>
            <img
              src={`${API}/api/images/${gen.image_id}`}
              alt="Generated"
              className="max-w-md rounded-lg shadow"
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
}
